import _classPrivateMethodInitSpec from "@babel/runtime/helpers/classPrivateMethodInitSpec";
import _classPrivateFieldInitSpec from "@babel/runtime/helpers/classPrivateFieldInitSpec";
import _assertClassBrand from "@babel/runtime/helpers/assertClassBrand";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet2";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet2";
const RETRY_TIMEOUT_UNIT = 1000;
export const RETRY_LIMIT = 5;
var _url = /*#__PURE__*/new WeakMap();
var _ws = /*#__PURE__*/new WeakMap();
var _queuedMessages = /*#__PURE__*/new WeakMap();
var _messageListeners = /*#__PURE__*/new WeakMap();
var _closeListeners = /*#__PURE__*/new WeakMap();
var _retryCount = /*#__PURE__*/new WeakMap();
var _closed = /*#__PURE__*/new WeakMap();
var _MessageService_brand = /*#__PURE__*/new WeakSet();
export class MessageService {
  constructor(url) {
    _classPrivateMethodInitSpec(this, _MessageService_brand);
    _classPrivateFieldInitSpec(this, _url, void 0);
    _classPrivateFieldInitSpec(this, _ws, void 0);
    _classPrivateFieldInitSpec(this, _queuedMessages, []);
    _classPrivateFieldInitSpec(this, _messageListeners, new Set());
    _classPrivateFieldInitSpec(this, _closeListeners, new Set());
    _classPrivateFieldInitSpec(this, _retryCount, 0);
    _classPrivateFieldInitSpec(this, _closed, false);
    _classPrivateFieldSet(_url, this, url);
  }
  send(data) {
    // Connect when data is sent for the first time
    if (!_classPrivateFieldGet(_ws, this)) {
      _classPrivateFieldSet(_ws, this, _assertClassBrand(_MessageService_brand, this, _connect).call(this));
    }
    const stringifiedData = JSON.stringify(data);
    if (_classPrivateFieldGet(_ws, this).readyState === WebSocket.OPEN) {
      _classPrivateFieldGet(_ws, this).send(stringifiedData);
    } else {
      _classPrivateFieldGet(_queuedMessages, this).push(stringifiedData);
    }
  }
  onMessage(listener) {
    _classPrivateFieldGet(_messageListeners, this).add(listener);
    return () => {
      _classPrivateFieldGet(_messageListeners, this).delete(listener);
    };
  }
  onClose(listener) {
    _classPrivateFieldGet(_closeListeners, this).add(listener);
    return () => {
      _classPrivateFieldGet(_closeListeners, this).delete(listener);
    };
  }
  reset() {
    _classPrivateFieldGet(_queuedMessages, this).length = 0;
    _classPrivateFieldGet(_messageListeners, this).clear();
    _classPrivateFieldGet(_closeListeners, this).clear();
  }
  close() {
    var _classPrivateFieldGet2;
    _classPrivateFieldSet(_closed, this, true);
    if (((_classPrivateFieldGet2 = _classPrivateFieldGet(_ws, this)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.readyState) === WebSocket.OPEN) {
      _classPrivateFieldGet(_ws, this).close();
    }
  }
}
function _connect() {
  // eslint-disable-next-line no-console
  console.log("WebSocket connecting ...");
  const ws = new WebSocket(_classPrivateFieldGet(_url, this));
  let resetRetryCountTimeout;
  ws.addEventListener("open", e => {
    // eslint-disable-next-line no-console
    console.log("WebSocket open:", e);

    // If server closes the socket not more than 1 second after it's opened,
    // we should not reset the retry count.
    resetRetryCountTimeout = setTimeout(() => {
      resetRetryCountTimeout = undefined;
      _classPrivateFieldSet(_retryCount, this, 0);
    }, 1e3);
    for (const msg of _classPrivateFieldGet(_queuedMessages, this)) {
      ws.send(msg);
    }
    _classPrivateFieldGet(_queuedMessages, this).length = 0;
  });
  ws.addEventListener("close", e => {
    if (_classPrivateFieldGet(_closed, this)) {
      return;
    }
    if (resetRetryCountTimeout !== undefined) {
      clearTimeout(resetRetryCountTimeout);
    }
    // eslint-disable-next-line no-console
    console.log("WebSocket close:", e);
    // Error code 1000 means that the connection was closed normally.
    if (e.code !== 1000) {
      _assertClassBrand(_MessageService_brand, this, _reconnect).call(this);
    }
  });
  ws.addEventListener("error", e => {
    // No need to reconnect in error event listener,
    // there will always be a close event along with the error event.
    // eslint-disable-next-line no-console
    console.error("WebSocket error:", e);
  });
  ws.addEventListener("message", e => {
    const response = JSON.parse(e.data);
    for (const listener of _classPrivateFieldGet(_messageListeners, this)) {
      listener(response);
    }
  });
  return ws;
}
function _reconnect() {
  // istanbul ignore next: currently can't mock this
  if (_classPrivateFieldGet(_retryCount, this) >= RETRY_LIMIT) {
    // eslint-disable-next-line no-console
    console.error("WebSocket connect retry limit exceeded");
    // Keep behavior as v2: emit close event only after retry limit exceeded
    for (const listener of _classPrivateFieldGet(_closeListeners, this)) {
      listener();
    }
    return;
  }
  // Double the timeout for each retry
  const delay = Math.pow(2, _classPrivateFieldGet(_retryCount, this)) * RETRY_TIMEOUT_UNIT;
  // eslint-disable-next-line no-console
  console.log("WebSocket will reconnect after %d seconds", delay / 1000);
  setTimeout(() => {
    var _this$retryCount, _this$retryCount2;
    _classPrivateFieldSet(_retryCount, this, (_this$retryCount = _classPrivateFieldGet(_retryCount, this), _this$retryCount2 = _this$retryCount++, _this$retryCount)), _this$retryCount2;
    _classPrivateFieldSet(_ws, this, _assertClassBrand(_MessageService_brand, this, _connect).call(this));
  }, delay);
}
//# sourceMappingURL=MessageService.js.map